import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { registerRoute } from '../utils/API_Routes';

import styled from 'styled-components';
import Logo from '../assets/logo.svg'
import 'react-toastify/dist/ReactToastify.css';
import { instance } from '../utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../features/auth/authSlice';
import { setUser } from '../features/user/userSlice';
import FormLoading from '../components/loading/FormLoading';

const Register = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [userr, setUserr] = useState({
        Username: "",
        Email: "",
        Password: "",
        ConfirmPassword: ""
    })
    const { user } = useSelector((state) => state.user);
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [navigate, user])

    const toastCreator = (msg, tost) => {
        const toastOptions = {
            position: 'bottom-right',
            autoClose: 8000,
            pauseOnHover: true,
            draggable: true,
            theme: 'dark'
        }
        tost(msg, toastOptions);
        return false;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (handleValidation()) {
            setIsLoading(true);
            const timer = setTimeout(() => {
                toastCreator('Server may take 30 seconds to respond', toast.info)
            }, 2500)
            const { data } = await instance.post(registerRoute, {
                ...userr
            },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            if (data.status === false) {
                clearTimeout(timer)
                toastCreator(data.msg, toast.error);
            }
            if (data.status === true) {
                clearTimeout(timer)
                dispatch(setUser(data))
                dispatch(setAuth({ accessToken: data.accessToken }))
                navigate('/');
            }
            setIsLoading(false)
        };
    }
    const handleChange = (e) => {
        setUserr((prevValue) => {
            return { ...prevValue, [e.target.name]: e.target.value }
        });
    }

    const handleValidation = () => {
        const { Password, ConfirmPassword, Username, Email } = userr;
        if (Username.length < 3) {
            return toastCreator('Username should be grater than 3 characters', toast.error)
        } else if (Password.length < 8) {
            return toastCreator('Password should be equal to or grater than 8 characters', toast.error)
        } else if (Email === "") {
            return toastCreator('email is required', toast.error)
        } else if (Password !== ConfirmPassword) {
            return toastCreator('Password and Confirm Password should be same', toast.error)
        }
        return true;
    }

    return (
        <>
            <FormContainer>
                <div className="form_wrapper">
                    <div className="brand">
                        <img src={Logo} alt="logo" />
                        <h1>Snappy</h1>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <input type="text" name="Username" onChange={handleChange} placeholder='Username' />
                        <input type="email" name="Email" onChange={handleChange} placeholder='Email' />
                        <input type="password" name="Password" onChange={handleChange} placeholder='Password' />
                        <input type="password" name="ConfirmPassword" onChange={handleChange} placeholder='Confirm Password' />
                        <button type="submit" disabled={isLoading}>{isLoading ? <FormLoading /> : "Create User"}</button>
                        <span>already have an account? <Link to='/login'>Login</Link></span>
                    </form>
                </div>
            </FormContainer>
            <ToastContainer />
        </>
    )
}

const FormContainer = styled.div`
    height:100vh;
    width:100vw ;
    background-color: rgb(19,18,36);
    display:flex ;
    justify-content:center ;
    align-items:center;
    .form_wrapper{
        display:flex;
        flex-direction:column;
        gap:2rem;
        border-radius:2rem;
        background-color:#00000076 ;
        padding:3rem 5rem ;
    }
    .brand{
        display:flex ;
        align-items:center;
        gap:1rem;
        justify-content:center;
        img{
            height:5rem;
        }
        h1{
            color:#ffffff;
            text-transform:uppercase ;
        }
    }
    form{
        display:flex;
        flex-direction:column;
        gap:2rem;
        input{
            background-color:transparent ;
            padding:1rem ;
            border:0.1rem solid #4e0eff;
            border-radius:0.4rem;
            color:white;
            width:100%;
            font-size:1rem;
            &:focus{
                border:0.1rem solid #997af0;
                outline:none;
            }
        }
        button{
            background-color:#997af0;
            color:white;
            border:none;
            font-weight:bold;
            height:48px ;
            display:flex ;
            align-items:center ;
            justify-content:center ;
            cursor:pointer;
            border-radius:0.4rem;
            font-size:1rem;
            text-transform:uppercase;
            position:relative ;
            transition:0.5s ease-in-out;
            &:hover{
            background-color:#4e0eff;
            }
        }
        span{
            color:white;
            text-transform:uppercase ;
            a{
                color:#4e0eff;
                text-decoration:none ;
                font-weight:bold ;
            }
        }
    }
`


export default Register